import { ButtonColorEnum, ButtonSizeEnum, ButtonTypeEnum, ButtonVariantEnum } from '@app/app.enum';
import { ICustomButtonProps } from '@app/models/shared.models';
import { Button, CircularProgress, Grid, Tooltip, Typography } from '@material-ui/core';
import { connect } from 'formik';
import _ from 'lodash';
import * as React from 'react';

const defaultProps: ICustomButtonProps = {
	type: ButtonTypeEnum.Submit,
	color: ButtonColorEnum.Secondary,
	fullWidth: false,
	disabled: false,
	ignoreFormikStateForDisable: false,
	buttonText: null,
	loading: false,
	variant: ButtonVariantEnum.Contained,
	size: ButtonSizeEnum.Medium,
	disableFocusRipple: false,
	children: null,
	href: null,
	onClick: () => {},
	autoFocus: false,
	className: '',
	formik: null,
};

const CustomButton = (props: ICustomButtonProps) => {
	const disabled = React.useMemo(
		() =>
			!_.isEmpty(props.formik) && !props.ignoreFormikStateForDisable
				? !props.formik.dirty || props.disabled
				: props.disabled,
		[props.disabled, props.formik?.dirty]
	);

	const button = (
		<>
			<Button
				type={props.type}
				fullWidth={props.fullWidth}
				color={props.color}
				disabled={disabled}
				variant={props.variant}
				size={props.size}
				disableFocusRipple={props.disableFocusRipple}
				href={props.href}
				onClick={(e) => props.onClick(e)}
				autoFocus={props.autoFocus}
				className={props.className}
			>
				{props.buttonText}
				{props.children}
				{props.loading && <CircularProgress size={24} className='ml-1' color='inherit' />}
			</Button>
			{props.helperText && (
				<Grid container={true} alignItems='center' className='pt-1'>
					<Grid item={true} xs={12}>
						<Typography variant='caption' color='textSecondary'>
							{props.helperText}
						</Typography>
					</Grid>
				</Grid>
			)}
		</>
	);

	if (!props.showTooltip) {
		return button;
	}

	return (
		<Tooltip title={props.tooltipTitle} placement={props.tooltipPosition}>
			{button}
		</Tooltip>
	);
};

CustomButton.defaultProps = defaultProps;

export default connect(CustomButton);



// WEBPACK FOOTER //
// ./src/components/shared/custom-button.component.tsx